<h1 mat-dialog-title *ngIf="!is401">
  <span [innerHtml]="titleError"></span>
  <button mat-button (click)="goOut()" class="btoCloseModal">
    <span>×</span>
  </button>
</h1>
<div mat-dialog-content *ngIf="!is401">
  <div *ngIf="!onlytext" class="contentError">
    <div class="contentImgError">
      <img [src]="imgError" alt="" />
    </div>
    <div
      class="contentTextError break-word"
      [innerHtml]="textContentError"
    ></div>
  </div>
  <div *ngIf="onlytext" class="contentOnlyText">
    <div
      class="contentTextError break-word"
      [innerHtml]="textContentError"
    ></div>
  </div>
  <div class="tech-expasion-panel mt-10" *ngIf="showHeaderExpasionPanel">
    <div class="tech-expasion-panel-header" (click)="clickTechExpasionPanel()">
      <span>{{ 'k003093' | translate }} </span>
      <!-- token: Detalles para nuestro equipo de programadores -->
      <fa-icon icon="angle-down" *ngIf="!showTechExpasionPanel"></fa-icon>
      <fa-icon icon="angle-up" *ngIf="showTechExpasionPanel"></fa-icon>
    </div>
    <div
      *ngIf="showTechExpasionPanel"
      [@inOutAnimation]
      class="matPanelContent fadeIn"
    >
      <div *ngIf="showTechExpasionPanel" class="contentImgCode">
        <ngx-qrcode [value]="data.error.ExceptionCode"></ngx-qrcode>
        <span>{{ data.status }}</span>
      </div>
      <div class="textCodeError" [innerHtml]="textCodeError"></div>
      <div class="span2">
        <button
          *ngIf="showTechExpasionPanel"
          type="button"
          class="buttonPortal w-100 mt-4"
          [cdkCopyToClipboard]="data.error.ExceptionCode"
          #tooltip0="matTooltip"
          matTooltipPosition="above"
          matTooltip="{{ 'k001886' | translate }}"
          (mouseenter)="$event.stopImmediatePropagation()"
          (mouseleave)="$event.stopImmediatePropagation()"
          (click)="tooltip0.show()"
        >
          <span>
            <fa-icon [icon]="['fal', 'copy']"></fa-icon>
            {{ 'k003094' | translate }}
          </span>
          <!-- Token: Clic aquí para copiar todos los
            detalles -->
        </button>
      </div>
    </div>
  </div>
</div>

<h1 mat-dialog-title *ngIf="is401">
  <span>{{ 'k004104' | translate }}</span>
  <button mat-button (click)="goOut2()" class="btoCloseModal">
    <span>×</span>
  </button>
</h1>

<div mat-dialog-content *ngIf="is401" class="error401-mat-dialog-content">
  <div class="error401-wrapper">
    <img
      alt=""
      class="img-error401"
      src="./assets/img/{{ customTheme }}/error/sentado.png"
    />
    <div class="content-error401">
      <p [innerHtml]="'k004105' | translate"></p>
      <p>{{ 'k004106' | translate }}</p>
    </div>
  </div>
</div>
